import { ResourceOptions } from 'react-admin';
import { FaMoneyCheckAlt } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.blindBoxWithdrawConfig;
export const icon = FaMoneyCheckAlt;
export const options: ResourceOptions = {
  label: 'module.blindBox.withdrawConfig',
};
